export const TUJUAN_KUNJUNGAN_NORMAL = "0";
export const TUJUAN_KUNJUNGAN_KONSUL = "2";
export const TUJUAN_KUNJUNGAN_PROSEDUR = "1";
export const TUJUAN_KUNJUNGAN_RUJUK_INTERNAL = "4";
export const TUJUAN_KUNJUNGAN_FISIOTERAPI = "5";

export const POLI_TUJUAN_IGD = "IGD - INSTALASI GAWAT DARURAT";

export const faqPembuatanSEP = `
1. Jika rujukan baru

    - Pilih tujuan kunjungan "Normal"
    - Wajib mengisi nomor rujukan

2. Jika pasien kontrol

    - Pilih tujuan kunjungan "Kontrol Dokter" 
    - Pilih Assesment Pelayanan
    - Wajib mengisi nomor kontrol dan nomor rujukan

3. Jika rujuk internal
    
    - Pilih tujuan kunjungan "Rujuk Internal"
    - Pilih Assesment Pelayanan
    - Wajib mengisi nomor rujukan.

4. Jika rujuk internal dihari yang sama

    - Pilih tujuan kunjungan "Prosedur"
    - Pilih Assesment Pelayanan
    - Pilih Flag Prosedur
    - Jika flag tidak berkelanjutan, kode penunjang tidak perlu diisi
    - Jika flag berkelanjutan, kode penunjang wajib diisi
`;

export const PILIH_TUJUAN_KUNJUNGAN = [
  {
    value: TUJUAN_KUNJUNGAN_NORMAL,
    label: "Normal",
  },
  {
    value: TUJUAN_KUNJUNGAN_PROSEDUR,
    label: "Prosedur",
  },
  {
    value: TUJUAN_KUNJUNGAN_KONSUL,
    label: "Kontrol Dokter",
  },
  {
    value: TUJUAN_KUNJUNGAN_RUJUK_INTERNAL,
    label: "Rujuk Internal",
  },
  {
    value: TUJUAN_KUNJUNGAN_FISIOTERAPI,
    label: "Fisio",
  },
];

export const PILIH_ASSESMENT_PELAYANAN = [
  {
    value: "",
    label: "Pilih",
  },
  {
    value: 1,
    label: "Radioterapi",
  },
  {
    value: 2,
    label: "Kemoterapi",
  },
  {
    value: 3,
    label: "Rehabilitasi Medik",
  },
  {
    value: 4,
    label: "Rehabilitasi Psikososial",
  },
  {
    value: 5,
    label: "Transfusi Darah",
  },
  {
    value: 6,
    label: "Pelayanan Gigi",
  },
  {
    value: 7,
    label: "Laboratorium",
  },
  {
    value: 8,
    label: "USG",
  },
  {
    value: 9,
    label: "Farmasi",
  },
  {
    value: 10,
    label: "Lain-Lain",
  },
  {
    value: 11,
    label: "MRI",
  },
  {
    value: 12,
    label: "HEMODIALISA",
  },
];

export const PILIH_ASSESMENT_PELAYANAN_SELAIN_NORMAL = [
  {
    value: "",
    label: "Pilih",
  },
  {
    value: 1,
    label: "Poli spesialis tidak tersedia pada hari sebelumnya",
    // disabled: true,
  },
  {
    value: 2,
    label: "Jam Poli telah berakhir pada hari sebelumnya",
  },
  {
    value: 3,
    label: "Dokter Spesialis yang dimaksud tidak praktek pada hari sebelumnya",
    // disabled: true,
  },
  {
    value: 4,
    label: "Atas Instruksi RS",
    // disabled: true,
  },
  {
    value: 5,
    label: "Tujuan Kontrol",
    // disabled: true,
  },
];

export const pembiayaanDanPenanggungJawab = [
  {
    value: "",
    label: "Pilih",
  },
  {
    value: 1,
    label: "Pribadi",
  },
  {
    value: 2,
    label: "Pemberi Kerja",
  },
  {
    value: 3,
    label: "Asuransi Kesehatan Tambahan",
  },
];
